export const visitedPageConstants = {
    GET_VISITED_PAGE_REQUEST: 'GET_VISITED_PAGE_REQUEST',
    GET_VISITED_PAGE_SUCCESS: 'GET_VISITED_PAGE_SUCCESS',
    GET_VISITED_PAGE_FAILURE: 'GET_VISITED_PAGE_FAILURE',

    SAVE_VISITED_PAGE_REQUEST: 'SAVE_VISITED_PAGE_REQUEST',
    SAVE_VISITED_PAGE_SUCCESS: 'SAVE_VISITED_PAGE_SUCCESS',
    SAVE_VISITED_PAGE_FAILURE: 'SAVE_VISITED_PAGE_FAILURE',
}